module.exports = __webpack_public_path__ + "img/logo2.af2f1a3d.png";